import React, { useContext, useState } from "react";
import "../../../assests/css/studentdashboard/HelpSupport.css";
import {
  FaQuestionCircle,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import Swal from "sweetalert2";
import axios from "axios";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import { AppContext } from "../../../context/Appcontext";
import { useLocation, useNavigate } from "react-router-dom";

const HelpSupport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const requestType = location.state?.request_type || "support";
  const referenceId = location.state?.reference_id || null;
  const issueType = location.state?.issue_type || "";
  const teacherId = location.state?.teacher_id || null;
  const adminId = location.state?.admin_id || null;

  const { baseUrl } = useContext(AppContext);
  const [selectissue, setSelectIssue] = useState(issueType);
  const [describeissue, setDescribeIssue] = useState("");

  // Add Support Request
  const addSupportRequest = () => {

    const student = JSON.parse(localStorage.getItem("student"));

    const formData = new FormData();

    formData.append("ngstudent_id", student.id);
    formData.append("request_type", requestType);

    if (referenceId !== null && referenceId !== undefined) {
      formData.append("reference_id", referenceId);
    }

    if (teacherId !== null && teacherId !== undefined) {
      formData.append("ngteacher_id", teacherId);
    }

    if (adminId !== null && adminId !== undefined) {
      formData.append("ngadmin_id", adminId);
    }

    formData.append("selectissue", selectissue);
    formData.append("describeissue", describeissue);
    formData.append("status", "Pending");

    console.log("DISPUTE DATA:", {
      ngstudent_id: student.id,
      ngteacher_id: teacherId,
      ngadmin_id: adminId,
      request_type: requestType,
      reference_id: referenceId,
      selectissue: selectissue,
      describeissue: describeissue,
      status: "Pending"
    });

    axios
      .post(
        `${baseUrl}/student/helpsupport/addHelpSupport`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {

        console.log("ADD SUPPORT RESPONSE:", response.data);

        if (response.data.success) {

          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Support Request Submitted Successfully",
            confirmButtonColor: "#6A88CE",
          }).then(() => {

            navigate("/student/myrequest");

          });

        } else {

          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.data.message || "Request could not be submitted.",
          });

        }

      })
      .catch((error) => {

        console.log(
          "ADD SUPPORT ERROR:",
          error.response?.data || error
        );

        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            error.response?.data?.error ||
            error.response?.data?.message ||
            "Something went wrong!",
        });

      });
  };

  return (

    <StudentsideLayout>

      {/* Topbar */}
      <header className="tgp-topbar">
        <h3>Welcome, Student 👋</h3>
        <div className="tgp-profile">👤</div>
      </header>

      <div className="ths-container">

        <h2 className="ths-title">
          Help & Support
        </h2>

        <p className="ths-subtitle">
          Need help? We’re here to support you.
        </p>

        {/* Support Cards */}
        <div className="ths-card-wrapper">

          <div className="ths-card">
            <FaQuestionCircle className="ths-icon" />

            <h4>FAQs</h4>

            <p>
              Find answers to common student panel questions.
            </p>
          </div>

          <div className="ths-card">
            <FaEnvelope className="ths-icon" />

            <h4>Email Support</h4>

            <p>support@schoolpanel.com</p>
          </div>

          <div className="ths-card">
            <FaPhoneAlt className="ths-icon" />

            <h4>Call Support</h4>

            <p>+92 300 1234567</p>
          </div>

        </div>

        {/* Contact Form */}
        <div className="ths-form-section">

          <h3>Contact Support</h3>

          <form className="ths-form">

            {/* <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            /> */}

            <select
              value={selectissue}
              onChange={(e) => setSelectIssue(e.target.value)}
            >

              <option value="">
                Select Issue Type
              </option>

              <option value="Technical Issue">
                Fee Issue
              </option>

              <option value="Technical Issue">
                Notes Issue
              </option>

              <option value="Attendance Issue">
                Attendance Issue
              </option>

              <option value="Exam / Result Issue">
                Exam / Result Issue
              </option>

            </select>

            <textarea
              placeholder="Describe your issue..."
              value={describeissue}
              onChange={(e) => setDescribeIssue(e.target.value)}
            />

            <button
              type="button"
              onClick={addSupportRequest}
            >
              Submit Request
            </button>

          </form>

        </div>

      </div>

    </StudentsideLayout>

  );
};

export default HelpSupport;